<template>
<div class="container">
  <div class="main__body">
    <div class="top__header van-hairline--bottom" v-if="userInfo!=null">
      <div class="van-cell van-cell--clickable ">
        <div class="van-cell__title user__info">
          <div class="img">
            <img :src="userInfo.avatarurl" />
          </div>
          <div class="info">
            <div class="name">
              <span>{{userInfo.nickname}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="todo__btn" v-if="loading==false && userInfo!=null">
      <van-cell-group>
        <van-cell icon="comment-o" title="加装意愿登记" is-link @click="$utils.jump('/register')" v-if="applyStatus==null"/>
        <van-cell icon="comment-o" title="查看登记信息" is-link @click="$utils.jump('/register/?id='+applyStatus.id)"v-else/>
      </van-cell-group>
    </div>
    <div class="todo__btn" v-if="loading==false && userInfo==null">
      <van-cell-group>
        <van-cell icon="comment-o" title="加装意愿登记" is-link @click="$utils.jump('/register')" />
        <van-cell icon="comment" title="查询登记信息" is-link @click="$utils.jump('/registerCheck')"/>
      </van-cell-group>
    </div>
  </div>
</div>
</template>
<script>
import {
  mapActions
}
from 'vuex'
export default {
  components: {},
  data() {
    return {
      userInfo: null,
      applyStatus:null,
      loading:false
    }
  },
  props: [],
  computed: {},
  watch: {},
  created() {
    scrollTo(0, 0)

  },
  mounted() {},
  methods: {
    init(){
        let userInfo = this.$utils.getStorage('userInfo')
        this.userInfo=userInfo
        if(userInfo!=null){
          this.checkApply()
        }
    },
    async checkApply() {
      let posData = {
        auth: true
      }
      this.loading=true
      let res = await this._checkApply(posData)
      this.loading=false
      if (res && res.code == 200) {
        this.applyStatus = res.data
      }
    },
    ...mapActions('api', ['_checkApply'])
  }
}
</script>
<style lang="less" scoped>
.container {
    .main__body {
        min-height: calc(100vh - 50px);
        padding-bottom: 50px;
        .top__header {
            margin-bottom: 15px;
            .van-cell {
                padding: 15px;
            }
            .user__info {
                display: flex;
                .img {
                    width: 60px;
                    height: 60px;
                    border-radius: 100%;
                    overflow: hidden;
                    img {
                        width: 100%;
                    }
                }
                .info {
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    .name {
                        span {
                            font-size: 16px;
                            color: #000000;
                            line-height: 20px;
                            font-weight: 700;
                        }
                    }
                }
            }
        }
    }
}
</style>
